import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step12 } from '../../../../shared/models/component-messages/diveIN/step12';
import { TypeVoie } from '../models/TypeVoie';

@Component({
  selector: 'app-type-voie',
  templateUrl: './type-voie.component.html'
})
export class TypeVoieComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeVoie';
  @Input() parentForm: FormGroup;
  @Input() voie: TypeVoie;
  @Input() disabled: boolean;
  @Input() rule: string;
  public step12 = new Step12();

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}

